/**
 * 文本
 * @author yuxin.zhang 2018.11.9
 */

import React from 'react';
import Select from 'react-select-okjp';
import InputNum from 'OK-InputNum';

import InputPassword from '_common/components/InputPassword';

import { FormType } from '../FormType';

import ItemContext from './ItemContext';
import LeftTitle from './LeftTitle';

const passwordType = 'password';

export default class ItemMultiInput extends ItemContext {
  constructor(props) {
    super(props);

    this.state = {
      errorMsg: '',
      dataError: false,
      value: '',
      multiValue: [], // FormType.MULTI_INPUT 输入值保存
      multiFocus: [],
      multiChanged: false,
      multiErrorIndex: '',
    };
  }

  UNSAFE_componentWillMount() {
    this.setValue(this.props.dataSource);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setValue(nextProps.dataSource);
    this.setError(nextProps.dataSource);
    this.cleanError(nextProps.dataSource);
    this.cleanValue(nextProps.dataSource);
  }

  setValue = (dataSource) => {
    const { key, formType, extend, onValSetFinished, inputList } = dataSource;
    if (inputList && inputList.length !== 0) {
      const multiValue = [];
      const multiKey = [];
      let exist = false;
      inputList.forEach((item) => {
        if (item.value !== undefined && item.value !== '') {
          exist = true;
        }
        multiValue.push(item.value === undefined ? '' : item.value);
        multiKey.push(item.key);
      });
      if (exist) {
        this.setState({ multiValue });
        onValSetFinished && onValSetFinished(key, formType, extend, multiKey);
      }
    }
  };

  /**
   * 输入值变化监听 用于一行多个输入框时的情况
   * @param e
   * @param index
   */
  onMultiValChange = (e, index) => {
    const { multiValue } = this.state;
    const { key, errorData, onChange, inputList, formType, extend, filter } =
      this.props.dataSource;
    // 获取当前焦点输入框的值
    let val = '';

    const itemFormType = inputList[index].formType;
    if (itemFormType === FormType.SELECT) {
      val = e ? e.value : '';
    } else {
      val = filter ? filter(e.target.value) : e.target.value;
    }

    let errorIndex = '';
    let errorMsg = '';

    for (let i = 0; i < inputList.length; i++) {
      const currentVal = index === i ? val : multiValue[i];

      // 根据总错误数据 获取错误信息
      errorMsg = this.getErrorMsg(currentVal, errorData);

      if (errorMsg.length === 0) {
        const inputErrorData = inputList[i].errorData
          ? inputList[i].errorData
          : null;
        if (inputErrorData) {
          // 根据自己的错误数据 获取错误信息
          errorMsg = this.getErrorMsg(currentVal, inputErrorData);
        }
      }

      // 取 错误更靠前的输入框
      if (errorMsg.length !== 0) {
        errorIndex = i;
        break;
      }
    }

    const multiErrorIndex = errorMsg.length !== 0 ? errorIndex : '';
    multiValue[index] = val;

    this.setState({
      multiChanged: true,
      multiValue,
      multiErrorIndex,
      errorMsg,
    });
    const allow = errorMsg.length === 0;

    const valObj = {};
    inputList.forEach((item, i) => {
      valObj[item.key] = multiValue[i];
    });
    onChange &&
      onChange(key, formType, multiValue, allow, extend, valObj, index);
  };

  // 聚焦事件
  onMultiFocus = (e) => {
    const { multiFocus } = this.state;
    const index = e.target.getAttribute('data-index');
    multiFocus[index] = true;
    this.setState({ multiFocus });
    if (
      this.state.errorMsg.length == 0 ||
      // 入力時はerror非表示とする
      index == this.state.multiErrorIndex
    ) {
      this.onFocus(e);
    }
  };

  // 失焦事件
  onMultiBlur = (e) => {
    this.onBlur(e);
    const { multiFocus } = this.state;
    const index = e.target.getAttribute('data-index');
    multiFocus[index] = false;
    this.setState({ multiFocus });
  };

  // 渲染下部提示
  renderTips(tips, isSpecial) {
    if (!tips || tips.length === 0) {
      return null;
    }
    return (
      <div className="tips-box">
        {tips.map((item, index) => {
          return (
            <div
              key={`tips${isSpecial ? 'Special' : ''}${index}`}
              className={`tips-item ${isSpecial ? 'especial' : ''}`}
            >
              {item}
            </div>
          );
        })}
      </div>
    );
  }

  /**
   * 渲染 一行多个输入框类型
   * @returns {*}
   */
  renderFormLineMultiText() {
    const { errorMsg, multiValue, multiFocus } = this.state;
    const { key, inputList, list, bottomArea } = this.props.dataSource;
    return (
      <div className="form-multi-box">
        <div className="form-multi-input-box">
          {inputList.map((item, index) => {
            const { formType, inputAttr, placeholderLeft, placeholderRight } =
              item;

            const isMoney = formType === FormType.MONEY;
            const isPassword =
              formType === FormType.PASSWORD ||
              (inputAttr && inputAttr.type === passwordType);
            // eslint-disable-next-line no-nested-ternary
            const inputClass = placeholderRight
              ? 'form-transparent-input'
              : placeholderLeft
              ? 'form-transparent-input form-top-input'
              : 'input multi-input';

            let Input = null;
            const attr = {
              key: item.key,
              value: multiValue[index],
              className: inputClass,
              onChange: (e) => {
                this.onMultiValChange(e, index);
              },
              onFocus: this.onMultiFocus,
              onBlur: this.onMultiBlur,
            };
            if (formType === FormType.SELECT) {
              Input = (
                <Select
                  {...inputAttr}
                  options={list || item.list}
                  data-index={index}
                  name="form-field-name"
                  className="select-type multi-input"
                  value={multiValue[index]}
                  clearable={false}
                  onChange={(select) => {
                    this.onMultiValChange(select, index);
                  }}
                />
              );
            } else if (isMoney) {
              // 金额类型
              Input = <InputNum {...inputAttr} {...attr} data-index={index} />;
            } else if (isPassword) {
              // 密码类型
              Input = (
                <InputPassword {...inputAttr} {...attr} data-index={index} />
              );
            } else {
              // 其他不需特殊处理的类型
              Input = (
                <input
                  type="text"
                  {...inputAttr}
                  {...attr}
                  data-index={index}
                />
              );
            }
            let formBox = Input;
            if (placeholderRight && placeholderRight.length !== 0) {
              formBox = (
                <div
                  className="mock-multi-input-box"
                  key={key + index}
                  data-focus={multiFocus[index]}
                >
                  <div className="mock-input" data-index={index} />
                  {Input}
                  <span className="placeholder-right">{placeholderRight}</span>
                </div>
              );
            }
            if (placeholderLeft && placeholderLeft.length !== 0) {
              formBox = (
                <div
                  className="mock-multi-input-box"
                  key={key + index}
                  data-focus={multiFocus[index]}
                >
                  <span className="placeholder-left">{placeholderLeft}</span>
                  {Input}
                  <div className="mock-input" data-index={index} />
                </div>
              );
            }
            return formBox;
          })}
        </div>
        <br />
        {bottomArea}
        <span className="form-error-tips">{errorMsg}</span>
      </div>
    );
  }

  render() {
    const { dataError, errorMsg, multiErrorIndex } = this.state;
    const { dataSource } = this.props;
    const { bottomTips } = dataSource;
    return (
      <div
        className="form-item"
        data-error={dataError && errorMsg && errorMsg.length !== 0}
        data-error-index={multiErrorIndex}
      >
        <LeftTitle dataSource={dataSource} />
        {this.renderFormLineMultiText()}
        {this.renderTips(bottomTips)}
        {dataSource.rightArea}
      </div>
    );
  }
}

ItemMultiInput.defaultProps = {
  dataSource: {
    key: '',
    extend: null,
    placeholderRight: null,
    placeholderLeft: null,
    formType: FormType.MULTI_INPUT,
    inputAttr: {},
    defaultValue: '',
    list: [],
    errorData: [],
    callback: null,
    onChange: null,
    onBlur: null,
    filter: (val) => {
      return val;
    },
  },
};
